/*!
 * DHL User Interface Library - https://docs.uilibrary.dhl
 *   9fbef606107a605d69c0edbcd8029e5d
 */
import { S as Sizes, V as Variants } from './constants-c94b83bd.js';

const DHL_ICON_WRAPPER_SIZES = {
    SM: Sizes.SM,
    MD: Sizes.MD,
    LG: Sizes.LG,
    XL: Sizes.XL,
};
const DHL_ICON_WRAPPER_VARIANTS = {
    ERROR: Variants.error,
    INVERTED: Variants.inverted,
    PRIMARY: Variants.primary,
    SECONDARY: Variants.secondary,
    SUCCESS: Variants.success,
    WARN: Variants.warn,
    NOTE: Variants.note,
};
const DHL_ICON_WRAPPER_ANIMATIONS = {
    SPIN: "spin",
    APPEAR_FROM_SIDE: "appearFromSide",
    APPEAR_FROM_TOP: "appearFromTop",
    DISAPPEAR_FROM_BOTTOM: "disappearFromBottom",
};
const DHL_ICON_WRAPPER_DURATION = {
    "0x": "0x",
    "1x": "1x",
    "2x": "2x",
    "3x": "3x",
    "4x": "4x",
    "5x": "5x",
    "infinite": "infinite",
};
const DHL_ICON_WRAPPER = {
    SIZE: DHL_ICON_WRAPPER_SIZES,
    VARIANT: DHL_ICON_WRAPPER_VARIANTS,
    ANIMATION: DHL_ICON_WRAPPER_ANIMATIONS,
    DURATION: DHL_ICON_WRAPPER_DURATION,
};

export { DHL_ICON_WRAPPER as D };

//# sourceMappingURL=constants-74686023.js.map